import type { TableSemanticSchema } from './types';

export const TowsSchema: TableSemanticSchema = {
  id: 'tows',
  name: 'TOWS Matrix',
  description:
    'Action-oriented extension of SWOT — pairs internal factors with external ones to generate strategies. Cells reference back to the source SWOT items.',
  cells: [
    { id: 'so', label: 'SO — Maxi-Maxi', row: 0, col: 0, hint: 'Use strengths to seize opportunities' },
    { id: 'wo', label: 'WO — Mini-Maxi', row: 0, col: 1, hint: 'Overcome weaknesses by seizing opportunities' },
    { id: 'st', label: 'ST — Maxi-Mini', row: 1, col: 0, hint: 'Use strengths to avoid threats' },
    { id: 'wt', label: 'WT — Mini-Mini', row: 1, col: 1, hint: 'Minimize weaknesses and avoid threats' },
  ],
  itemFields: [
    { key: 'strategyType', label: 'Strategy Type', kind: 'enum', required: true,
      options: [
        { value: 'so', label: 'SO' },
        { value: 'wo', label: 'WO' },
        { value: 'st', label: 'ST' },
        { value: 'wt', label: 'WT' },
      ] },
    { key: 'linkedSwotItems', label: 'Linked SWOT Items', kind: 'id-list',
      description: 'Which SWOT items this strategy draws from.' },
    { key: 'priority', label: 'Priority', kind: 'enum',
      options: [
        { value: 'high', label: 'High' },
        { value: 'medium', label: 'Medium' },
        { value: 'low', label: 'Low' },
      ] },
  ],
  renderingHints: { layout: 'quadrant' },
};
